import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { tap } from 'rxjs/operators';
import { CITService } from '../../services/cit.service';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.css']
})
export class ForgetPasswordComponent implements OnInit {
  form: FormGroup;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private citService: CITService,
    private toast: ToastrService
  ) {
  }

  ngOnInit() {
    this.createForm();
  }

  private createForm() {
    this.form = this.fb.group({
      email: [null, [Validators.required]]
    })
  }

  onSubmit() {
    const { email } = this.form.getRawValue();
    if (this.form.invalid) {
      return this.form.markAllAsTouched();
    }
    this.citService.forgetPassword({ email: email, source: "CIT"})
      .pipe(
        tap((res) => this.toast.success("Please check your email to reset your password")),
        tap((res) => this.router.navigate(['ems/login']))
      ).subscribe();

  }

}
